// Owner: account-settings (plan §3.2, §9.3). /settings: the settings index (cards on desktop, a list on
// phones) of every page the member may open.
import { createFileRoute } from '@tanstack/react-router';
import { SettingsIndexPage } from '../../../features/account/SettingsIndexPage';

export const Route = createFileRoute('/_settings/settings/')({
  component: SettingsIndexPage,
});
